import React from 'react';
import { Puzzle } from 'lucide-react';

const IntegrationSection = () => {
  return (
    <section className="py-20 px-8" style={{ backgroundColor: '#d4896a' }}>
      <div className="max-w-5xl mx-auto">
        <div className="text-center">
          <h3 className="text-3xl lg:text-4xl font-bold text-white mb-8">
            "Practice Dashboard plugs directly into your existing Practice CS environment. This means there's no need to switch systems or disrupt your workflow—just add Practice Dashboard and enhance the features you rely on every day."
          </h3>
          
          <div className="flex items-center justify-center text-white text-lg">
            <Puzzle className="w-6 h-6 mr-3" />
            <span className="font-medium">Part of TS Practice CS ecosystem</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntegrationSection;